module.exports = __webpack_public_path__ + "img/00006.8d7ca52d.webp";